import React, { ChangeEvent, FC, Fragment } from 'react'
import classNames from 'classnames'
import styles from 'styles/components/form.module.scss'
import text from 'styles/utility/text.module.scss'
import { DeleteIconButton, TextButton } from 'components/Button'
import { FlexRow } from 'components/Flex'
import { SelectBox, TextInput } from 'components/Form'
import { Spacer } from 'components/Utility'
import { PointCardGradeType } from 'types/pointCard'
import { useSelectOptionsAmount } from 'hooks/form'

type Props = {
  grades: PointCardGradeType[]
  addGrade: () => void
  deleteGrade: (index: number) => void
  handleGradeName: (index: number, e: ChangeEvent<HTMLInputElement>) => void
  handleGradeThreshold: (index: number, value: string) => void
}

const PointCardGradeForm: FC<Props> = (props) => {
  const { grades, addGrade, deleteGrade, handleGradeName, handleGradeThreshold } = props
  const gradeThresholdOptions = useSelectOptionsAmount({ total: 100, unit: 100, startIndex: 0, unitString: 'pt' })

  const setPlaceholder = (index: number) => {
    const placeholderNames = ['スタンダード', 'シルバー', 'ゴールド', 'プラチナ', 'ダイヤモンド', 'ブラック']
    return placeholderNames[index]
  }

  return (
    <>
      <div className={styles.column_two}>
        <div className={classNames(styles.column_two__item, text.font_small)}>グレード名</div>
        <Spacer size={8} />
        <div className={classNames(styles.column_two__item, text.font_small)}>必要なポイント数</div>
        <Spacer size={36} />
      </div>
      <Spacer size={8} />
      {grades.map((grade, index) => (
        <Fragment key={index}>
          <div className={styles.column_two}>
            <div className={classNames(styles.column_two__item)}>
              <TextInput
                disabled={false}
                onChange={(e) => handleGradeName(index, e)}
                placeholder={setPlaceholder(index)}
                required={true}
                size={'small'}
                type={'text'}
                value={grade.name}
              />
            </div>
            <Spacer size={8} />
            <div className={classNames(styles.column_two__item)}>
              <SelectBox
                disabled={index === 0}
                options={gradeThresholdOptions.filter((option) =>
                  index > 0 ? parseInt(grades[index - 1]?.threshold.toString()) < parseInt(option.value) : true
                )}
                select={(value) => handleGradeThreshold(index, value)}
                value={grade.threshold}
              />
            </div>
            {index >= 3 ? (
              <>
                <Spacer size={8} />
                <DeleteIconButton onClick={() => deleteGrade(index)} />
              </>
            ) : index === 0 ? (
              <>
                <Spacer size={8} />
                <p className={classNames(styles.column_initial, text.font_bold, text.font_xxsmall)}>初期</p>
              </>
            ) : (
              <Spacer axis={'horizontal'} size={36} />
            )}
          </div>
          {index !== grades.length - 1 && <Spacer size={8} />}
        </Fragment>
      ))}
      <Spacer size={16} />
      <FlexRow justifyContent={'center'}>
        <TextButton
          disabled={grades.length === 6}
          iconPath={'/icon/blue/plus.svg'}
          label={'グレードを追加する'}
          onClick={addGrade}
        />
      </FlexRow>
    </>
  )
}

export default PointCardGradeForm
